<!--
 * @Author: 仙道
 * @Date: 2022-08-22 20:56:27
 * @LastEditTime: 2022-09-22 18:28:45
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/video/modules/jessibucaBack.vue
-->
<!--
 * @Author: Junjie
 * @Date: 2022-05-31 00:40:52
 * @LastEditTime: 2022-08-22 20:54:44
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/video/modules/jessibuca.vue
-->
<template>
  <div
    :ref="`container${refkey}`"
    @dblclick="fullscreenSwich"
    style="width:100%;height:100%;background-color: #000000;margin:0 auto;"
  >
    <div class="buttons-box" id="buttonsBox">
      <div class="buttons-box-left">
        <a-icon @click="playBtnClick" class="jessibuca-btn" type="play-circle" v-if="!playing" />
        <a-icon @click="pause" class="jessibuca-btn" type="pause-circle" v-if="playing" />
        <a-icon @click="destroy" class="jessibuca-btn" type="stop" />
        <a-icon @click="jessibuca.mute()" class="jessibuca-btn" theme="filled" type="audio" v-if="isNotMute" />
        <a-icon @click="jessibuca.cancelMute()" class="jessibuca-btn" type="audio" v-if="!isNotMute" />
      </div>
      <div class="buttons-box-right">
        <span class="jessibuca-btn">{{ kBps }} kb/s</span>
        <!--          <i class="iconfont icon-file-record1 jessibuca-btn"></i>-->
        <!--          <i class="iconfont icon-xiangqing2 jessibuca-btn" ></i>-->

        <a-icon
          @click="jessibuca.screenshot('截图','png',0.5)"
          class="jessibuca-btn"
          style="font-size: 1rem !important"
          type="picture"
        />
        <a-icon @click="playBtnClick" class="jessibuca-btn" type="reload" />
        <a-icon @click="fullscreenSwich" class="jessibuca-btn" type="fullscreen" v-if="!fullscreen" />
        <a-icon @click="fullscreenSwich" class="jessibuca-btn" type="fullscreen-exit" v-if="fullscreen" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'jessibuca',
    data () {
      return {
        jessibuca: null,
        playing: false,
        isNotMute: false,
        quieting: false,
        fullscreen: false,
        loaded: false, // mute
        speed: 0,
        performance: "", // 工作情况
        kBps: 0,
        btnDom: null,
        videoInfo: null,
        volume: 1,
        rotate: 0,
        vod: true, // 点播
        forceNoOffscreen: false,
      };
    },
    props: ['videoUrl', 'error', 'hasAudio', 'height', 'refkey'],
    created () {

    },
    mounted () {
      // this.create()
      this.create()
      window.onerror = (msg) => {
        console.error(msg)
      };
      let paramUrl = decodeURIComponent(this.$route.params.url)
      //   window.onresize = () => {
      //     this.updatePlayerDomSize()
      //   }
      const that = this
      this.$nextTick(() => {
        //   that.jessibuca.play(that.videoUrl)
        // that.updatePlayerDomSize()

        if (typeof (this.videoUrl) == "undefined") {
          that.videoUrl = paramUrl;
        }

      })
      this.btnDom = document.getElementById("buttonsBox");
      console.log("初始化时的地址为: " + this.videoUrl)
      // this.play(this.videoUrl)
    },
    unmounted () {
      this.jessibuca.destroy();
    },
    watch: {
      videoUrl: {
        handler: function (newValue, oldValue) {
          if (!newValue) return
          //   this.play(newValue)
        },
        immediate: true

      },
    },

    methods: {
      updatePlayerDomSize () {
        let dom = this.$refs[`container${this.refkey}`];
        let width = dom.parentNode.clientWidth
        let height = (9 / 16) * width

        const clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
        if (height > clientHeight) {
          height = clientHeight
          width = (16 / 9) * height
        }

        dom.style.width = width + 'px';
        dom.style.height = height + "px";
      },
      create () {
        const dom = this.$refs[`container${this.refkey}`]

        this.jessibuca = new window.Jessibuca(
          {

            container: dom,
            isFlv: true,
            isResize: true,
            hasAudio: false,
            videoBuffer: 0.2, // 缓存时长
            isResize: false,
            text: "",
            decoder: "/decoder.js",

            loadingText: "加载中",
            useMSE: false,
            // useWCS: false,
            debug: true,
            showBandwidth: true, // 显示网速
            operateBtns: {
              fullscreen: false,
              screenshot: false,
              play: false,
              audio: false,
              recorder: false
            },
            forceNoOffscreen: this.forceNoOffscreen,
            isNotMute: this.isNotMute
          })
        // options


        const _this = this;
        this.jessibuca.on("load", function () {
          _this.jessibuca.play(_this.videoUrl)
        });

        this.jessibuca.on("pause", function () {
          _this.playing = false;
        });
        // this.jessibuca.on("play", function () {
        //   _this.playing = true;

        // });
        this.jessibuca.on("play", () => {
          _this.playing = true;
          _this.loaded = true;
          _this.quieting = _this.jessibuca.quieting;
        });
        this.jessibuca.on("fullscreen", function (msg) {
          console.log("on fullscreen", msg);
          _this.fullscreen = msg
        });

        this.jessibuca.on("mute", function (msg) {
          console.log("on mute", msg);
          _this.isNotMute = !msg;
        });

        let _ts = 0;
        this.jessibuca.on("timeUpdate", function (ts) {
          // console.log('timeUpdate,old,new,timestamp', _ts, ts, ts - _ts);
          _ts = ts;
        });



        this.jessibuca.on("performance", function (performance) {
          let show = "卡顿";
          if (performance === 2) {
            show = "非常流畅";
          } else if (performance === 1) {
            show = "流畅";
          }
          _this.performance = show;
        });


        this.jessibuca.on('kBps', function (kBps) {
          _this.kBps = Math.round(kBps);
        });

      },

      playBtnClick: function (event) {
        this.play(this.videoUrl)
      },
      play: function (url) {
        console.log(url)

        // if (this.jessibuca) {
        //   this.destroy();
        // }
        // this.create();
        // this.jessibuca.on("play", () => {
        //   this.playing = true;
        //   this.loaded = true;
        //   this.quieting = this.jessibuca.quieting;
        // });
        this.$nextTick(() => {
          //   this.jessibuca.on("load", () => {
          //     console.log("load 播放")
          //     this.jessibuca.play(url);
          //   });
        })
        // if (this.jessibuca.hasLoaded()) {
        //   this.jessibuca.play(url);
        // } else {
        //   this.jessibuca.on("load", () => {
        //     console.log("load 播放")
        //     this.jessibuca.play(url);
        //   });
        // }
      },
      pause: function () {
        if (this.jessibuca) {
          this.jessibuca.pause();
        }
        this.playing = false;
        this.err = "";
        this.performance = "";
      },
      destroy: function () {
        if (this.jessibuca) {
          this.jessibuca.destroy();
        }
        if (document.getElementById("buttonsBox") == null) {
          this.$refs.container.appendChild(this.btnDom)
        }
        this.jessibuca = null;
        this.playing = false;
        this.err = "";
        this.performance = "";

      },
      eventcallbacK: function (type, message) {
        // console.log("player 事件回调")
        // console.log(type)
        // console.log(message)
      },
      fullscreenSwich: function () {
        let isFull = this.isFullscreen()
        this.jessibuca.setFullscreen(!isFull)
        this.fullscreen = !isFull;
      },
      isFullscreen: function () {
        return document.fullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement || false;
      }

    },
    destroyed () {
      if (this.jessibuca) {
        this.jessibuca.destroy();
      }
      this.playing = false;
      this.loaded = false;
      this.performance = "";
    },
  }
</script>

<style lang="less" scoped>
  .jessibuca-container {
    // height: 98% !important;
  }

  .buttons-box {
    width: 100%;
    height: 28px;
    background-color: rgba(43, 51, 63, 0.7);
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    left: 0;
    bottom: 0;
    user-select: none;
    z-index: 1;
  }

  .jessibuca-btn {
    width: 20px;
    color: rgb(255, 255, 255);
    line-height: 27px;
    margin: 0px 10px;
    padding: 0px 2px;
    cursor: pointer;
    text-align: center;
    font-size: 0.8rem !important;
  }

  .buttons-box-right {
    position: absolute;
    right: 0;
  }
</style>
